<script>
  import { navigate } from 'svelte-navigator'

  import oAuthConfig from '../oauth_config.js'
  import { setToken } from '../oauth.js'

  const params = new URLSearchParams(document.location.search)
  console.log(params)

  if (params.has('code')) {
    console.log(
      'Callback after authorize called and code provided',
      params.get('code')
    )

    // Exchange code for token
    const formData = new FormData()
    formData.append('client_id', oAuthConfig.clientId)
    formData.append('grant_type', 'authorization_code')
    formData.append('code', params.get('code'))
    formData.append('redirect_uri', oAuthConfig.redirectTarget)

    fetch(oAuthConfig.host + '/o/token/', {
      method: 'POST',
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          // Something went wrong when turning the code for token, reload
          // Typical casees include that the code was already exchanged as
          // it can be only exchanged once. Or that too much time based since
          // the creation of the code and trying to exchange it.
          console.log(response.text())
          navigate('/', { replace: true })
        }

        // Convert response into JSON
        return response.json()
      })
      .then((newToken) => {
        console.log('Retrieved Token', newToken)
        setToken(newToken)
        navigate('/', { replace: true })
      })
  }
</script>
